import React from "react";
import { cn } from "@/lib/utils";
import PhoneInputComponent, { PhoneInputProps } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ disabled, inputClass, country, onChange, ...rest }, ref) => {
    return (
      <PhoneInputComponent
        {...rest}
        country={country}
        disabled={disabled}
        countryCodeEditable={false}
        enableSearch
        onChange={(phone, countryData, event, formattedValue) => {
          const isCountrySelection = event.type !== "change" && "dialCode" in countryData;
          const number = isCountrySelection ? countryData.dialCode : phone;
          const value = number ? `+${number}` : "";
          onChange?.(value, countryData, event, isCountrySelection ? value : formattedValue);
        }}
        inputClass={cn(
          "!w-[100%] !h-[40px] !border !border-g-200 !rounded-md",
          disabled ? "opacity-50 cursor-not-allowed" : "",
          inputClass
        )}
        inputProps={{
          ref,
          disabled: disabled,
        }}
      />
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
